import { render, staticRenderFns } from "./consolidations.vue?vue&type=template&id=a31a6f22"
import script from "./consolidations.vue?vue&type=script&lang=js"
export * from "./consolidations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports